import classNames from 'classnames';
import useSubtitle from 'src/hooks/useSubtitle';
import { IconSize } from 'src/interfaces/Icon';
import { detectMobile } from 'src/utils/browserUtils';
import SubtitleToggle from '../../components/SubtitleToggle';
import Description from '../../components/Text/Description';
import Title from '../../components/Text/Title';
import styles from './styles.module.scss';

export interface IHeaderProps {
  title?: string;
  description?: string;
}

const Header = ({ title, description }: IHeaderProps) => {
  const { toggleSubtitle, subtitleEnabled, subtitles } = useSubtitle();

  const isMobile = detectMobile();

  return (
    <div className={classNames(styles.container, { [styles.mobile]: isMobile })}>
      <div className={classNames(styles.column, styles.leftSide)}>
        {title && <Title>{title}</Title>}
        {description && <Description>{description}</Description>}
      </div>
      <div className={classNames(styles.column, styles.rightSide)}>
        <div className={classNames(styles.mobileOnly, { [styles.show]: isMobile })}>
          {subtitles && (
            <SubtitleToggle iconSize={IconSize.small} isEnabled={subtitleEnabled} onClick={toggleSubtitle} />
          )}
        </div>
      </div>
    </div>
  );
};

export default Header;
